class CartWatcher {
  constructor() {
    this.lastCartCount = null;
  }

  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch("/cart.js");

    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem("cart", JSON.stringify(cart));
  }

  storedCart() {
    return JSON.parse(localStorage.getItem("cart")) || { items: [] };
  }

  updateCartCountBadge(cart) {
    if (cart.item_count === undefined) return;

    if (cart.item_count !== this.lastCartCount) {
      const cartCounter = document.querySelector(".cart-count-badge");
      const ampCart = document.querySelector(".amp-cart");

      if (cartCounter) {
        if (cart.item_count > 0) {
          cartCounter.textContent = cart.item_count;
          cartCounter.classList.remove("hidden");
        } else {
          cartCounter.textContent = "";
          cartCounter.classList.add("hidden");
        }
      }

      if (ampCart) {
        if (cart.item_count > 0) {
          ampCart.classList.remove("false");
          ampCart.classList.add("amp-cart--open");
        } else {
          ampCart.classList.add("false");
          ampCart.classList.remove("amp-cart--open");
        }
      }

      this.lastCartCount = cart.item_count;
    }
  }

  async checkAndUpdateCartCount() {
    try {
      const cart = await this.fetchCart();
      this.updateCartCountBadge(cart);
    } catch (error) {
      console.warn("Unable to update cart count:", error);
    }
  }

  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) =>
      l.filter((li) => !r.some((ri) => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach((oi) => {
      const ni = newCart.items.find(
        (i) => i.key == oi.key && i.quantity != oi.quantity
      );
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0 ? result.added.push(item) : result.removed.push(item);
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    this.updateCartCountBadge(newCart);

    const event = new CustomEvent("cart_changed", { detail: changes });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ["xmlhttprequest", "fetch"].includes(
          entry.initiatorType
        );
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.checkAndUpdateCartCount();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}
const myCartWatcher = new CartWatcher();
myCartWatcher.init();

window.addEventListener("cart_changed", (cart) => {
  //console.log(cart.detail);
});
